import { keyframes, style } from '@vanilla-extract/css';
import { baseTokenVars } from '@tundr/ds-tokens';
import { spacingVars } from '@tundr/ds-foundations';

const LOADER_ROTATION_DURATION = '1s';
const LOADER_WRAPPER_HEIGHT_PX = 300;
const LOADER_STROKE_WIDTH_PX = 6;

const rotate = keyframes({
  '100%': { transform: 'rotate(1turn)' },
});

export const loaderClass = style({
  display: 'inline-block',
  borderRadius: '50%',
  background: `
    radial-gradient(farthest-side, ${baseTokenVars.color.grey['400']} 94%, #0000) top / ${LOADER_STROKE_WIDTH_PX}px ${LOADER_STROKE_WIDTH_PX}px no-repeat,
    conic-gradient(#0000 30%, ${baseTokenVars.color.grey['400']})
  `,
  WebkitMask: `radial-gradient(farthest-side, #0000 calc(100% - ${LOADER_STROKE_WIDTH_PX}px), #000 0)`,
  mask: `radial-gradient(farthest-side, #0000 calc(100% - ${LOADER_STROKE_WIDTH_PX}px), #000 0)`,
  willChange: 'transform',
  animationName: rotate,
  animationDuration: LOADER_ROTATION_DURATION,
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
  '@media': {
    '(prefers-reduced-motion: reduce)': {
      animationName: 'none',
    },
  },
});

export const loaderWrapperClass = style({
  display: 'flex',
  height: LOADER_WRAPPER_HEIGHT_PX,
  justifyContent: 'center',
  alignItems: 'center',
  padding: `${spacingVars.lg} 0`,
});

export const loaderWrapperAutoHeightClass = style({
  height: 'auto',
});
